import { z } from 'zod';
import { IssueStatus } from './IIssueShared';

export const issueStatusUpdatedNotificationMetadataSchema = z.object({
	projectId: z.string(),
	description: z.string(),
	issueId: z.string(),
	newStatus: z.enum(IssueStatus),
	prevStatus: z.enum(IssueStatus),
	userThatChangedStatus: z.string().optional(),
});

export type IIssueStatusUpdatedNotificationMetadata = z.infer<typeof issueStatusUpdatedNotificationMetadataSchema>;
